export function createActionCreator(type, ...argNames) {
    return (...args) => {
        const action = { type }
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index]
        })
        return action
    }
}

export function createReducer(initialState, handlers) {
    return function reducer(state = initialState, action, fullState) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action, fullState)
        }
        else {
            return state
        }
    }
}

export function combineReducersWithFullState(subReducers) {
    return function reducer(oldState = {}, action) {
        return Object.entries(subReducers).reduce(
            (newState, [name, subReducer]) => ({...newState, [name]: subReducer(oldState[name], action, oldState)}),
            {}
        )
    } 
}

export function perKeyReducer(key, reducerOnKey) {
    return function reducer(oldState = {}, action) {
        const keyValue = action[key]
        if (keyValue == null) {
            return oldState;
        }
        else {
            return {
                ...oldState, 
                [keyValue]: reducerOnKey(oldState[keyValue], action)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/redux.js